@use "../../../styles/Constants.scss" as Constants;
@use "../../../styles/Colors.scss" as Colors;

$var-shadow: 0 1px 4px 0 Colors.$col-shadow;
$var-submit-action-top-offset: -16px;
$var-tabs-navigation-top-offset: 48px;
$var-lost-for-reason-width: 250px;

.work-request-preview {

	&__back-to-list {
		background-color: Colors.$col-white !important;
		margin-bottom: Constants.$val-spacing-m;
	}

	&__submit-section {
		display: flex;
		align-items: center;
		background-color: Colors.$col-white;
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;
		z-index: 3;
		border-bottom: 2px solid Colors.$col-greyBackground;
		top: $var-submit-action-top-offset;
		position: sticky;

		& > * + * {
			margin-left: Constants.$val-spacing-xs;
		}

		&__in-progress-status {
			&>button>div {
				font-weight: bold;
				color: Colors.$col-yellow;
			}
		}

		&__lost-status {
			&>button>div {
				font-weight: bold;
				color: Colors.$col-canceledRed;
			}

			&__reason {
				max-width: $var-lost-for-reason-width;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
			}
		}

		&__won-status {
			&>button>div {
				font-weight: bold;
				color: Colors.$col-green;
			}
		}

		&__locked-in-status {
			color: Colors.$col-blue;
			cursor: pointer;
			font-weight: bold;
			margin-left: Constants.$val-spacing-m;

			&:hover {
				color: Colors.$col-darkBlueBorder;
			}
		}

		&__status {
			flex: 1;
			display: flex;
			align-items: center;

			&--in-progress {
				color: Colors.$col-yellow;
			}

			&--won {
				background-color: Colors.$col-green;
			}

			&--lost {
				background-color: Colors.$col-canceledRed;
			}

			&--locked-in {
				color: Colors.$col-blue;
				cursor: pointer;

				&:hover {
					color: Colors.$col-darkBlueBorder;
				}
			}

			&__dropdown {
				>div>div {
					z-index: 100 !important;
				}
			}
		}

		&__actions {
			display: flex;
			gap: Constants.$val-spacing-xs;
		}

	}

	&__tabs-navigation {
		position: sticky;
		top: $var-tabs-navigation-top-offset;
	}

	&__tab-content {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-m;
		margin-top: Constants.$val-spacing-s;

		&__section {
			display: grid;
			row-gap: Constants.$val-spacing-l;
			background-color: Colors.$col-white;
			box-shadow: $var-shadow;
			padding: Constants.$val-spacing-m Constants.$val-spacing-l;

			&__title {
				text-transform: uppercase;
				color: Colors.$col-design-grey11;
				row-gap: 0;
				font-size: Constants.$val-fontSizeSmall;
			}

			:global([class^="_label_"]) + &__row {
				margin-top: Constants.$val-spacing-m;
			}

			&__row {
				display: grid;
				grid-template-columns: repeat(8, 1fr);

				&__column-1 {
					grid-column: span 1;
				}

				&__column-2 {
					grid-column: span 2;
				}

				&__column-4 {
					grid-column: span 4;
				}

				&__column-6 {
					grid-column: span 6;
				}

				&__column-8 {
					grid-column: span 8;
				}

				&__centered-column {
					display: flex;
					align-items: center;
				}
			}
		}
	}

	&__associated-work-request {
		&>a {
			display: flex;
			align-items: center;
			color: Colors.$col-blue;

			&>[class^="icon-external"] {
				margin-right: Constants.$val-spacing-s;
			}
		}
	}

	&__address-map-container {
		padding-left: 0;
		padding-right: 0;
	}
}

@mixin cell-text {
	font-size: Constants.$val-fontSizeSmall;
}

.work-request-preview-table {
	&__cell-text {
		@include cell-text;

		&__blue {
			@include cell-text;
			color: Colors.$col-blue;
			text-transform: uppercase;
		}

		&__uppercase {
			@include cell-text;
			text-transform: uppercase;
		}
	}

	&__light-text {
		@include cell-text;
		color: Colors.$col-design-grey10;
		text-transform: uppercase;
	}
}